<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader">
        <div class="headerCon acea-row row-center-wrapper">
          <div>
            <div class="name">學術人數(人)</div>
            <div>
              <span class="num"
                >{{ userInfo.certification_type == 3 ? first + second : ""
                }}{{
                  userInfo.certification_type == 4
                    ? first + second + third
                    : ""
                }}{{
                  userInfo.certification_type == 5
                    ? first + second + third + four
                    : ""
                }}{{
                  userInfo.certification_type == 6
                    ? first + second + third + four + five
                    : ""
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="nav acea-row row-around">
        <div
          class="item"
          :class="screen.grade == 0 ? 'on' : ''"
          @click="checkGrade(0)"
        >
          一級({{ first }})
        </div>
        <div
          class="item"
          :class="screen.grade == 1 ? 'on' : ''"
          @click="checkGrade(1)"
          v-if="userInfo.certification_type > 2"
        >
          二級({{ second }})
        </div>
        <div
          class="item"
          :class="screen.grade == 2 ? 'on' : ''"
          @click="checkGrade(2)"
          v-if="userInfo.certification_type > 3"
        >
          三級({{ third }})
        </div>
        <div
          class="item"
          :class="screen.grade == 3 ? 'on' : ''"
          @click="checkGrade(3)"
          v-if="userInfo.certification_type > 4"
        >
          四級({{ four }})
        </div>
        <div
          class="item"
          :class="screen.grade == 4 ? 'on' : ''"
          @click="checkGrade(4)"
          v-if="userInfo.certification_type > 5"
        >
          五級({{ five }})
        </div>
      </div>
      <div class="search acea-row row-center-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="點擊搜索會員名稱" v-model="screen.keyword" />
            <span class="iconfont icon-guanbi"></span>
          </div>
        </form>
        <!-- <div class="iconfont icon-sousuo2"></div> -->
      </div>
    </div>
    <div class="list">
      <div
        class="sortNav acea-row row-middle"
        :class="fixedState === true ? 'on' : ''"
      >
        <div class="sortItem" @click="sort('childCount')">
          團隊排序
          <img src="@assets/moblie/images/sort1.png" v-if="childCount == 1" />
          <img src="@assets/moblie/images/sort2.png" v-if="childCount == 2" />
          <img src="@assets/moblie/images/sort3.png" v-if="childCount == 3" />
        </div>
        <div class="sortItem" @click="sort('numberCount')">
          銷量排序
          <img src="@assets/moblie/images/sort1.png" v-if="numberCount == 1" />
          <img src="@assets/moblie/images/sort2.png" v-if="numberCount == 2" />
          <img src="@assets/moblie/images/sort3.png" v-if="numberCount == 3" />
        </div>
        <!--
        <div class="sortItem" @click="sort('orderCount')">
          订单排序
          <img src="@assets/moblie/images/sort1.png" v-if="orderCount == 1" />
          <img src="@assets/moblie/images/sort2.png" v-if="orderCount == 2" />
          <img src="@assets/moblie/images/sort3.png" v-if="orderCount == 3" />
        </div>
        -->
      </div>
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item"
          v-for="(val, index) in spreadList"
          :key="index"
          :style="
            val.certification_type == '醫生'
              ? 'background-color:#ff000075;'
              : ''
          "
        >
          <div class="person acea-row row-between-wrapper">
            <div class="picTxt acea-row row-between-wrapper">
              <div class="pictrue"><img :src="val.avatar" /></div>
              <div class="text">
                <div class="name line1">
                  {{ val.nickname
                  }}<span
                    v-if="
                      val.certification_type != '患者' &&
                        val.certification_type != '醫生'
                    "
                    >--{{ typeNames[index] }}</span
                  >
                  <p
                    class="brokerage"
                    v-if="val.brokerage > 0 && val.certification_type != '患者'"
                  >
                    ({{ val.brokerage }})
                  </p>
                </div>
                <div
                  v-if="val.certification_type == '醫生' && val.isAgree == 2"
                >
                  審核狀態：{{
                    val.isAgree == 0
                      ? "待審核"
                      : val.isAgree == 1
                      ? "審核通過"
                      : "審核不通過"
                  }}
                </div>
                <div>加入时间: {{ val.time }}</div>
              </div>
            </div>
            <div v-if="val.certification_type == '醫生' && val.isAgree == 1">
              <div class="user-poster" @click.stop="showUserPoster(val.uid)">
                <!--  -->
              </div>
              <div :style="{ color: 'rgb(72,173,241)' }">推广码</div>
            </div>
          </div>
          <div class="right" v-if="val.certification_type != '患者'">
            <div class="block" @click="viewSales(val.uid)">
              <div class="number">
                {{ val.numberCount ? val.numberCount : 0 }}
              </div>
              <div>销售数量(盒)</div>
            </div>
            <div class="block" @click="viewOrders(val.uid)">
              <div class="number">{{ val.orderCount }}</div>
              <div>销售订单(单)</div>
            </div>
            <div class="block" @click="viewDetail(val.uid)">
              <div class="number">
                <span class="font-color-red">{{ val.childCount }}</span>
              </div>
              <div>团队人数(人)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getGroupCount } from "../../../../api/user";
import Loading from "@components/moblie/Loading";
import { mapGetters } from "vuex";
export default {
  name: "PromoterList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
        keyword: "",
        sort: "",
        uid: ""
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      first: "",
      second: "",
      third: "",
      four: "",
      five: "",
      certification_type: 0
    };
  },
  mounted: function() {
    this.getSpreadUsers();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSpreadUsers();
    });
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters(["userInfo"]),
    typeNames() {
      return this.spreadList.map(item => {
        switch (item.certification_type) {
          case 0:
            return (item.certification_type = "");
          case 1:
            return (item.certification_type = "患者");
          case 2:
            return (item.certification_type = "醫生");
          case 3:
            return (item.certification_type = "代表");
          case 4:
            return (item.certification_type = "代理");
          case 5:
            return (item.certification_type = "省代");
          case 6:
            return (item.certification_type = "总代");
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      console.log(from);
      if (from.path == `/user/promoter_list`) {
        this.screen.page = 0;
        this.loaded = false;
        this.loading = false;
        this.spreadList = [];
        this.getSpreadUsers();
        // window.reload();
      }
      window.location.reload();
    },
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    }
  },
  methods: {
    changUrl: function(val) {
      // 需过滤医生角色
      if (val.certification_type !== "患者" && this.screen.grade == 0) {
        var uid = val.uid;
        var certification_type = this.userInfo.certification_type;
        //console.log(certification_type)
        this.$router.push({
          //核心语句
          path: "/user/doctor_data", //跳转的路径
          query: {
            //路由传参时push和query搭配使用 ，作用时传递参数
            id: uid,
            certification_type: certification_type,
            grade: this.screen.grade
          }
        });
      } else if (this.screen.grade > 0) {
        this.$router.push(
          `/user/promote_router?certification_type=${this.screen.grade}&uid=${
            val.uid
          }`
        );
      }
    },
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    },
    getSpreadUsers: function() {
      let that = this,
        screen = that.screen;
      let { uid } = this.$route.params;
      let { certification_type } = this.$route.query;
      this.certification_type = certification_type;
      screen.uid = uid;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getGroupCount(screen).then(
        res => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.data.list);
          that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底線的" : "上拉加載更多";
          that.screen.page = that.screen.page + 1;
          that.first = res.data.total;
          that.second = res.data.totalLevel;
          that.third = res.data.totalLevel2;
          that.four = res.data.totalLevel3;
          that.five = res.data.totalLevel4;
          console.log(that.spreadList);
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        this.screen.grade = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    sort: function(types) {
      let that = this;
      switch (types) {
        case "childCount":
          if (that.childCount == 2) {
            that.childCount = 1;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount DESC";
          } else if (that.childCount == 1) {
            that.childCount = 3;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount ASC";
          } else if (that.childCount == 3) {
            that.childCount = 2;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "";
          }
          break;
        case "numberCount":
          if (that.numberCount == 2) {
            that.numberCount = 1;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount DESC";
          } else if (that.numberCount == 1) {
            that.numberCount = 3;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount ASC";
          } else if (that.numberCount == 3) {
            that.numberCount = 2;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        case "orderCount":
          if (that.orderCount == 2) {
            that.orderCount = 1;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount DESC";
          } else if (that.orderCount == 1) {
            that.orderCount = 3;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount ASC";
          } else if (that.orderCount == 3) {
            that.orderCount = 2;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        default:
          that.screen.sort = "";
      }
    },
    showUserPoster(uid) {
      this.$router.push({
        path: `/user/poster?uid=${uid}`
      });
    },
    viewDetail(uid) {
      this.$router.push(`/user/group_number/${uid}`);
    },
    viewSales(uid) {
      this.$router.push(`/user/group_order/${uid}`);
      // window.reload();
    },
    viewOrders(uid) {
      this.$router.push(`/user/group_orders/0/${uid}`);
      // window.reload();
    }
  }
};
</script>
<style scoped>
.border-red {
  border-color: red;
}
</style>
